import { useMutation, useQueryClient } from '@tanstack/react-query';
import { detachProductsFromGroup } from '../services/security-groups';

export function useDetachSecurityGroupMutation(productId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sgId: string) => detachProductsFromGroup(sgId, [productId]),
    onSuccess: (_data, sgId) => {
      qc.invalidateQueries({ queryKey: ['security', 'products', productId, 'groups'] });
      qc.invalidateQueries({ queryKey: ['security-groups'] });
      qc.invalidateQueries({ queryKey: ['security-group', sgId, 'products'] });
      qc.invalidateQueries({ queryKey: ['security-group', sgId] });
    },
  });
}
